<div class="page-container" [class.loading]="!settingsMenuService.areDependenciesLoaded">
    <app-header
        title="{{ 'settings.notifications.header' | translate }}"
        [menuService]="settingsMenuService"
    ></app-header>

    <div class="ui segment">
        <app-segment-header title="{{ 'settings.notifications.sectionHeader' | translate }}"></app-segment-header>
        <div class="ui divider"></div>

        <!-- Suppress All -->
        <div class="flex-row">
            <h3 class="ui header">
                {{ 'settings.notifications.allNotificationsSettingLabel' | translate }}
                <div *ngIf="showOfferLetterText" class="sub header">
                    {{ 'settings.notifications.allNotificationsSettingDescriptionWithOfferLetter' | translate }}
                </div>
                <div *ngIf="!showOfferLetterText" class="sub header">
                    {{ 'settings.notifications.allNotificationsSettingDescriptionWithoutOfferLetter' | translate }}
                </div>
            </h3>
            <mat-slide-toggle
                color="primary"
                [ngModel]="enableNotifications"
                (ngModelChange)="onSave($event)"
                name="enableAll"
            ></mat-slide-toggle>
        </div>

        <!-- Performance -->
        <div class="flex-row">
            <h3 class="ui header">
                {{ 'settings.notifications.performanceSettingLabel' | translate }}
                <div class="sub header">{{ 'settings.notifications.performanceSettingDescription' | translate }}</div>
            </h3>
            <ui-button type="primary" url="performance">
                {{ 'settings.notifications.performanceSettingEditButton' | translate }}
            </ui-button>
        </div>
    </div>
</div>
